import React from 'react';
import {Navbar, Nav, NavDropdown} from 'react-bootstrap';
import './css/customThemes.css';

//<Nav> 
//<Nav.Link href="#Login"><b>Login</b></Nav.Link>
//</Nav>
export default function NavbarSite(){
    return (
        <div>
        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
        <Nav>
          <Nav.Link href="/"><b>HOME</b></Nav.Link>
          <Nav.Link href="/#about"><b>ABOUT</b></Nav.Link>
          <Nav.Link href="/group"><b>GROUP</b></Nav.Link>
          <b>
          <NavDropdown title="VISUALIZATIONS" id="basic-nav-dropdown" menuVariant="dark" >
            <NavDropdown.Item href="/map"><b>MAP</b></NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown title="CHEMICAL DATA" id="basic-nav-dropdown" drop="end" menuVariant="dark">
            <NavDropdown.Item href="/overview"><b>OVERVIEW</b></NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="/molnet"><b>MOLECULAR NETWORK</b></NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown title="EXPLORE" id="basic-nav-dropdown" drop="end" menuVariant="dark">
              <NavDropdown.Item href="/explorelist"><b>GENUS LIST</b></NavDropdown.Item>
              <NavDropdown.Item href="/explore"><b>SEARCH</b></NavDropdown.Item>
            </NavDropdown>
            <NavDropdown.Divider />
            </NavDropdown>
            <NavDropdown.Divider />
            <NavDropdown title="TAXONOMY DATA" id="basic-nav-dropdown" drop="end" menuVariant="dark">
              <NavDropdown.Item href="/taxoverview"><b>TAXONOMY OVERVIEW</b></NavDropdown.Item>
            </NavDropdown>
            <NavDropdown.Divider />
        </NavDropdown>
        </b>
          <Nav.Link href="/contact"><b>CONTACT</b></Nav.Link>
        </Nav>
        
        </Navbar.Collapse>
      </Navbar>
      </div>
      );
}